module.exports = __webpack_public_path__ + "img/people-36.8abd7b47.png";